import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes, IconType,
} from 'app/enums/common.enums'
import TextIcon from 'app/common/DomainObject/ComponentMapper/TextIcon/TextIcon'
import {
    RegionZeroLevel, ServiceProcess, ServiceCenterStatus, ServiceCenterType,
} from 'app/enums/label.enums'

import {
    ServiceCentersTableType,
} from './serviceCenters.types'

const config: SkyNetTableConfig<keyof ServiceCentersTableType> = {
    name: 'ServiceCenter',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'serviceCenterNumber',
                reduced: true,
                mapCellProps: ({
                    serviceCenterNumber,
                    estimatedClosureDate,
                }) => {
                    return {
                        value: serviceCenterNumber,
                        type: estimatedClosureDate ? IconType.OrangeWarning : undefined,
                        tooltip: `Estimated Closure Date ${estimatedClosureDate}`,
                    }
                },
                Cell: TextIcon,
                labelKey: 'ServiceCenters.serviceCenterNumber',
            },
            {
                name: 'locationLocationName',
                filterField: 'locationLocationName',
                filterType: FilterType.Array,
                labelKey: 'ServiceCenters.location',
                reduced: true,
            },
            {
                name: 'serviceCenterStatus',
                filterField: 'serviceCenterStatus',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: ServiceCenterStatus,
                labelKey: 'ServiceCenters.serviceCenterStatus',
            },
            {
                name: 'serviceCenterType',
                filterField: 'serviceCenterType',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: ServiceCenterType,
                labelKey: 'ServiceCenters.serviceCenterType',
            },
            {
                name: 'orderSelectionDelay',
                labelKey: 'ServiceCenters.orderSelectionDelay',
            },
            {
                name: 'enabledProcesses',
                componentName: 'EnumList',
                allowedValuesEnum: ServiceProcess,
                labelKey: 'ServiceCenters.enabledProcesses',
            },
            {
                name: 'regionZeroLevel',
                filterField: 'regionZeroLevel',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: RegionZeroLevel,
                labelKey: 'Country.regionZeroLevel',
            },
        ],
    }],
}

export default config
